// Base styles first, so hero and section rules override them in the cascade.
import "./HomeRound5.css";
import "./blue2/base.css";
import { useFonts } from "./blue2/bits";
import { EventStrip } from "./blue2/EventStrip";
import { Hero } from "./blue2/Hero";
import { Making, Club, KindWords } from "./blue2/SectionsA";
import { Favorites, WhereIllBe, Brands, Loop, Footer } from "./blue2/SectionsB";
import { Part, rootStyle } from "./blue2/parts";

/* The blue "Hi, I'm chelsea" homepage in the team's palette, landed on the
   "Team mix" (see blue2/parts.tsx). */

export function HomeBlue2() {
  useFonts();
  return <div className="h5 b2" style={rootStyle}>
    <EventStrip />
    <Part p="hero"><Hero /></Part>
    <Part p="making"><Making /></Part>
    <Part p="club"><Club /></Part>
    <Part p="words"><KindWords /></Part>
    <Part p="faves"><Favorites /></Part>
    <Part p="where"><WhereIllBe /></Part>
    <Part p="brands"><Brands /></Part>
    <Part p="loop"><Loop /></Part>
    <Part p="footer"><Footer /></Part>
  </div>;
}
